import getOr from "lodash/fp/getOr";

export class Potential {
  constructor(ctyCode, totalExportPotential, untappedPotential, easeOfTrade) {
    this.ctyCode = ctyCode;
    this.totalExportPotential = totalExportPotential;
    this.untappedPotential = untappedPotential;
    this.easeOfTrade = easeOfTrade;
  }
  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      const ctyCode = getOr("", "ctyCode")(input);
      const totalExportPotential = getOr("", "totalExportPotential")(input);
      const untappedPotential = getOr("", "untappedPotential")(input);
      const easeOfTrade = getOr("", "easeOfTrade")(input);
      return new Potential(ctyCode, totalExportPotential, untappedPotential, easeOfTrade);
    }
    return new Potential();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Potential.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [Potential.fromApiObject(input)];
    }
    return [];
  }
}